import { IDonViHanhChinh } from "../../../model/respone/category/IDonViHanhChinh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDonViHanhChinhActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDonViHanhChinh[],
  LOAD_ERRR: "",
};
export const eDonViHanhChinhActionIds = generateActionTypeIds(
  eDonViHanhChinhActionsObj,
  "DON_VI_HANH_CHINH"
);
export type IDonViHanhChinhActionTypes = IGenericActionType<
  typeof eDonViHanhChinhActionsObj,
  "DON_VI_HANH_CHINH"
>;
